import {useEffect,useState} from 'react';

type Kind='communications'|'waivers'|'completed_tasks';
type RecordRow={id:string;at:string;title?:string|null;type?:string;
  content?:string;version?:string|null;project?:string|null;
  estimate?:string|null;assignee?:string|null};
const title=(kind:Kind)=>kind==='communications'?'communications':
  kind==='waivers'?'Waiver History':'Completed Tasks';
const date=(at:string)=>{
  const value=new Date(at);
  return Number.isNaN(value.getTime())?at:new Intl.DateTimeFormat('en-US',{
    month:'short',day:'numeric',year:'numeric',hour:'numeric',minute:'2-digit',
  }).format(value);
};
/** Small independently addressable popup matching owner-supplied Helm layouts.
 * No records shown until actually imported. All reads are permission-scoped.
 */
export function UserHistoryWorkspace({staffId,locationCode,kind}:{
  staffId:string;locationCode:string;kind:Kind;
}){
  const [name,setName]=useState('');
  const [rows,setRows]=useState<RecordRow[]>([]);
  const [status,setStatus]=useState<'loading'|'ready'|'error'>('loading');
  useEffect(()=>{
    const controller=new AbortController();
    setStatus('loading');
    void fetch('/api/v1/staff/team/'+encodeURIComponent(staffId)+
      '/history?'+new URLSearchParams({location:locationCode,kind}),{
      signal:controller.signal,credentials:'same-origin',cache:'no-store',
    }).then(async response=>{
      if(!response.ok)throw Error('History is unavailable.');
      const result=await response.json() as {ok:boolean;data?:{
        displayName:string;records:RecordRow[]}};
      if(!result.ok||!result.data)throw Error('History is unavailable.');
      if(controller.signal.aborted)return;
      setName(result.data.displayName);
      setRows(result.data.records);
      setStatus('ready');
    }).catch(()=>{if(!controller.signal.aborted)setStatus('error');});
    return ()=>controller.abort();
  },[staffId,locationCode,kind]);
  return <main className="ecfs-user-history-popup" aria-label="User history popup">
    <h1>{name||'User'} {title(kind)}</h1>
    {status==='loading'&&<p role="status">Loading history…</p>}
    {status==='error'&&<p role="alert">History cannot be loaded.</p>}
    {status==='ready'&&<>
      <table><thead>
        {kind==='waivers'
          ?<tr><th>Signed</th><th>Waiver</th><th>Version</th></tr>
          :kind==='communications'
            ?<tr><th>Sent</th><th>Content</th></tr>
            :<tr><th>Project</th><th>Task</th><th>Completed</th><th>Est.</th>
              <th>Assignees</th></tr>}
      </thead><tbody>
        {rows.map(record=>kind==='waivers'
          ?<tr key={record.id}><td>{date(record.at)}</td>
            <td>{record.title}</td><td>{record.version??'—'}</td></tr>
          :kind==='communications'
            ?<tr key={record.id}><td>{record.type} {date(record.at)}</td>
              <td><strong>{record.title}</strong>
                <div>{record.content}</div></td></tr>
            :<tr key={record.id}><td>{record.project??'—'}</td>
              <td>{record.title}</td><td>{date(record.at)}</td>
              <td>{record.estimate??'—'}</td><td>{record.assignee??'—'}</td>
            </tr>)}
      </tbody></table>
      {!rows.length&&<p role="status">{kind==='waivers'?'No waiver history.':
        kind==='communications'?'No communications.':'No completed tasks.'}</p>}
    </>}
  </main>;
}
